var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 mb-2"},[_c('table-app',{ref:"tabela",attrs:{"data":_vm.relatorios,"columns":_vm.columns,"actions":_vm.actions},on:{"open":_vm.open}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }